(ns frontend.page-components.events
  (:require
   [basic-components.modal :as zap-modal]
   [common.localization :as loc]
   [basic-components.inputs.footprint :refer [editor]]
   [frontend.view.modals.events :as modals]
   [frontend.actions.login :as login-actions]
   [frontend.account :as account]
   [frontend.logging :as logging]
   [frontend.actions.account :as account-actions]
   [frontend.state.current-session :as session]
   [frontend.actions.feedback :as feedback-actions]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [basic-components.attachments :as attachments-view]
   [frontend.db :as app-db]
   [frontend.analytics :as analytics]))


(defn toggle-sandbox!
  []
  (login-actions/*<-toggle-sandbox {}
                                   (fn [res]
                                     (let [body (:body res)
                                           {:keys [:account :token :tenant :target :role]} body]
                                       (account/update-session :email (:account/email account)
                                                               :token token
                                                               :account account
                                                               :intercom-hash (:intercom-hash body)
                                                               :tenant tenant
                                                               :role role
                                                               :target target
                                                               :switching-tenant? true))
                                     (js/setTimeout (fn []
                                                      (set! (.-pathname js/window.location) "/"))
                                                    30))
                                   (fn [e]
                                     (logging/error "Failed to toggle sandbox : " e))))

(defn send-feedback!
  [data on-success! on-error!]
  (feedback-actions/*->send
   data
   on-success!
   on-error!))

(defn create-feedback!
  [state]
  (feedback-actions/*->create-feedback
   {}
   (fn [{:keys [body]}]
     (let [created-feedback-id body]
       (swap! state assoc :feedback-id created-feedback-id)
       (logging/info "created feedback id " created-feedback-id)))
   (fn [err]
     (logging/error "Failed to create feedback " err))))

(defn cancel-feedback!
  [feedback-id state]
  (feedback-actions/*->cancel
   feedback-id
   (fn [resp]
     (swap! state dissoc :feedback-id)
     (logging/info "Successfully deleted feedback " resp))
   (fn [err]
     (logging/error "Failed to create feedback " err))))

(defn add-attachment-to-feedback!
  [{:keys [state db/id on-success! on-error!]} {:keys [files original-event]}]
  (when (aget files 0)
    (let [file (aget files 0)
          name (.-name file)
          size (.-size file)
          attachment {:filename    name
                      :description nil
                      :file        file
                      :target      id}
          token-success! (fn [token]
                           (attachments-view/add-indicator! state token name size)
                           (attachment-actions/*=>add-attachment
                            {:multipart-params (assoc attachment :token token)}
                            (fn [resp]
                              (attachments-view/remove-indicator! state token)
                              (on-success! (:body resp)))
                            (fn [resp]
                              (on-error! (:body resp))
                              (attachments-view/show-indicator-error! state token (loc/tr :attachment-indicator-error)))))]
      (common-actions/*<-create-op-token nil
                                         token-success!
                                         (fn [e]
                                           (logging/error "resp token=" e))))))
